export enum SelectionEnum {
    None = 0,
    PlanningBlock = 1,
    TransportOrder = 2,
    Orderline = 3
}